/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ConexaGenericError } from '@/services/httpClient'
import { toast } from '@conexasaude/conexa-hero'

export const showErrorToast = (
  error: ConexaGenericError,
  actionCallback?: () => void,
): void => {
  if (error?.response?.data?.msg?.includes('INVALID_ACCESS_TOKEN')) {
    toast({
      message: error?.response?.data?.msg,
      variant: 'error',
      action: () => {
        sessionStorage?.clear()
        actionCallback?.()
      },
      actionLabel: 'Reiniciar',
    })
    return
  }
  if (
    error?.response?.data?.toString() ===
    'Erro de validação na requisição no campo: token'
  ) {
    toast({
      message: 'Token inválido ou expirado',
      variant: 'error',
      action: () => {
        sessionStorage?.clear()
        actionCallback?.()
      },
      actionLabel: 'Reiniciar',
    })
    return
  }
  if (!error?.response) {
    toast({
      message: 'Conexão perdida.',
      variant: 'error',
      autoCloseDuration: 5000,
    })
    return
  }
  toast({
    message: error?.response?.data?.msg,
    variant: 'error',
  })
}
